/**
 * Animations Module
 * Handles scroll-based animations with Intersection Observer
 */

/**
 * Initialize animations
 */
export const initAnimations = () => {
    // Skip animations if user prefers reduced motion
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }

    initFadeInAnimations();
    initCountUpAnimations();
};

/**
 * Initialize fade-in animations for elements
 */
const initFadeInAnimations = () => {
    const animatedElements = document.querySelectorAll('.service-card, .stat-card, .section-title');

    if (animatedElements.length === 0) return;

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.style.opacity = '0';
                    entry.target.style.transform = 'translateY(20px)';
                    entry.target.style.transition = 'opacity 0.6s ease, transform 0.6s ease';

                    // Trigger animation
                    setTimeout(() => {
                        entry.target.style.opacity = '1';
                        entry.target.style.transform = 'translateY(0)';
                    }, 100);

                    // Unobserve after animation
                    observer.unobserve(entry.target);
                }
            });
        },
        {
            threshold: 0.2,
            rootMargin: '0px 0px -50px 0px'
        }
    );

    animatedElements.forEach((element) => observer.observe(element));
};

/**
 * Initialize count-up animations for stat numbers
 */
const initCountUpAnimations = () => {
    const statNumbers = document.querySelectorAll('.stat-number');

    if (statNumbers.length === 0) return;

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    animateCount(entry.target);
                    observer.unobserve(entry.target);
                }
            });
        },
        {
            threshold: 0.5
        }
    );

    statNumbers.forEach((element) => observer.observe(element));
};

/**
 * Animate number counting up
 */
const animateCount = (element) => {
    const target = parseInt(element.textContent.replace(/\D/g, ''), 10);
    const duration = 2000; // 2 seconds
    const increment = target / (duration / 16); // 60 FPS
    let current = 0;

    const updateCount = () => {
        current += increment;

        if (current < target) {
            element.textContent = Math.floor(current).toLocaleString('de-DE');
            requestAnimationFrame(updateCount);
        } else {
            element.textContent = target.toLocaleString('de-DE');
        }
    };

    updateCount();
};
